(function(){
  var STORAGE_KEY = 'esCartBrowseState.v2';
  var RETURN_KEY = 'esCartReturnIntent.v2';
  var FALLBACK_URL = routeUrl('collections/all-glasses');
  var MAX_AGE_MS = 1000 * 60 * 60 * 6;
  var LOCK_FALLBACK_MS = 7000;
  var CLICK_ARM_RELEASE_MS = 1600;
  var LOADING_TOAST_DELAY_MS = 480;
  var saveTimer = 0;

  function now(){ return Date.now ? Date.now() : new Date().getTime(); }

  function isSessionStorageAvailable(){
    try {
      var key = '__es_test__';
      window.sessionStorage.setItem(key, '1');
      window.sessionStorage.removeItem(key);
      return true;
    } catch(e) {
      return false;
    }
  }

  var hasSessionStorage = isSessionStorageAvailable();

  function parseJSON(raw){
    if (!raw) return null;
    try { return JSON.parse(raw); } catch(e) { return null; }
  }

  function read(key){
    if (!hasSessionStorage) return null;
    return parseJSON(window.sessionStorage.getItem(key));
  }

  function write(key, value){
    if (!hasSessionStorage) return;
    try { window.sessionStorage.setItem(key, JSON.stringify(value)); } catch(e) {}
  }

  function remove(key){
    if (!hasSessionStorage) return;
    try { window.sessionStorage.removeItem(key); } catch(e) {}
  }

  function toUrl(url){
    try { return new URL(url, window.location.origin); } catch(e) { return null; }
  }

  function normalize(url){
    var u = toUrl(url);
    if (!u) return '';
    if (u.origin !== window.location.origin) return '';
    return (u.pathname || '/') + (u.search || '') + (u.hash || '');
  }

  function samePage(a, b){
    var ua = toUrl(a); var ub = toUrl(b);
    if (!ua || !ub) return false;
    if (ua.origin !== ub.origin) return false;
    return (ua.pathname + ua.search) === (ub.pathname + ub.search);
  }

  function isRestorableUrl(url){
    var u = toUrl(url);
    if (!u || u.origin !== window.location.origin) return false;
    var path = String(u.pathname || '/').toLowerCase();
    if (!path) return false;
    if (isCartUrl(u.href) || isCheckoutUrl(u.href)) return false;
    if (path.indexOf('/challenge') === 0) return false;
    if (path.indexOf('/tools/') === 0) return false;
    return true;
  }

  function getCurrentHref(){
    return window.location.pathname + window.location.search + window.location.hash;
  }

  function routeUrl(path){
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '/') + String(path || '').replace(/^\//, '');
  }

  function isCartUrl(url){
    var target = toUrl(url);
    var cart = toUrl(routeUrl('cart'));
    if (!target || !cart || target.origin !== cart.origin) return false;
    var path = String(target.pathname || '').replace(/\/$/, '');
    var cartPath = String(cart.pathname || '').replace(/\/$/, '');
    return path === cartPath || path.indexOf(cartPath + '/') === 0;
  }

  function isCheckoutUrl(url){
    var target = toUrl(url);
    var checkout = toUrl(routeUrl('checkout'));
    if (!target || !checkout || target.origin !== checkout.origin) return false;
    var path = String(target.pathname || '').replace(/\/$/, '');
    var checkoutPath = String(checkout.pathname || '').replace(/\/$/, '');
    return path === checkoutPath || path.indexOf(checkoutPath + '/') === 0;
  }


  function isAddToCartForm(form){
    return !!(form && form.matches && form.matches('form[action*="/cart/add"]'));
  }

  function isAddToCartSubmitControl(control){
    if (!control || !control.matches) return false;
    return control.matches('button[type="submit"], input[type="submit"], button[name="add"], input[name="add"]');
  }

  function clearClickArmedState(form){
    if (!form || !form.setAttribute) return;
    form.removeAttribute('data-es-cart-click-armed');
    var controls = form.querySelectorAll ? form.querySelectorAll('[data-es-cart-pending="1"]') : [];
    controls.forEach(function(control){
      if (!control) return;
      control.removeAttribute('data-es-cart-pending');
      control.classList.remove('es-cart-submit-pending');
      removeBusyPresentation(control);
      if (control.getAttribute('data-es-cart-locked') !== '1') {
        control.removeAttribute('aria-busy');
      }
    });
  }

  function armControlPending(form, control){
    if (!isAddToCartForm(form) || !control || !control.setAttribute) return;
    form.setAttribute('data-es-cart-click-armed', '1');
    control.setAttribute('data-es-cart-pending', '1');
    control.setAttribute('aria-busy', 'true');
    control.classList.add('es-cart-submit-pending');
    applyBusyPresentation(control, 'Opening cart…');
    if (form.__esClickArmTimer) {
      try { window.clearTimeout(form.__esClickArmTimer); } catch(e) {}
    }
    form.__esClickArmTimer = window.setTimeout(function(){
      form.__esClickArmTimer = 0;
      if (form.getAttribute('data-es-cart-submitting') === 'true') return;
      clearClickArmedState(form);
    }, CLICK_ARM_RELEASE_MS);
  }

  function removeBusyPresentation(control){
    if (!control || !control.removeAttribute) return;
    control.removeAttribute('data-es-cart-status-label');
    control.removeAttribute('data-es-cart-icon-only');
    control.removeAttribute('data-es-cart-busy-copy');
  }

  function getControlPlainText(control){
    if (!control) return '';
    try {
      return String(control.textContent || '').replace(/\s+/g, ' ').trim();
    } catch(e) {
      return '';
    }
  }

  function isIconOnlyControl(control){
    if (!control || !control.querySelector) return false;
    var text = getControlPlainText(control);
    if (text && text.length > 1) return false;
    return !!control.querySelector('svg, i, img');
  }

  function applyBusyPresentation(control, label){
    if (!control || !control.setAttribute) return;
    var busyLabel = String(label || 'Opening cart…');
    control.setAttribute('data-es-cart-status-label', busyLabel);
    if (isIconOnlyControl(control)) {
      control.setAttribute('data-es-cart-icon-only', '1');
    } else {
      control.setAttribute('data-es-cart-busy-copy', busyLabel);
    }
  }

  function ensureToastRoot(){
    var root = document.querySelector('[data-es-cart-toast-root]');
    if (root) return root;
    root = document.createElement('div');
    root.className = 'es-cart-toast-stack';
    root.setAttribute('data-es-cart-toast-root', '1');
    root.setAttribute('aria-live', 'polite');
    root.setAttribute('aria-atomic', 'true');
    document.body.appendChild(root);
    return root;
  }

  function hideToast(id){
    if (!id) return;
    var node = null;
    if (typeof id === 'string') {
      node = document.querySelector('[data-es-cart-toast-id="' + String(id).replace(/"/g, '&quot;') + '"]');
    } else if (id && id.nodeType === 1) {
      node = id;
    }
    if (!node) return;
    if (node.__esToastTimer) {
      try { window.clearTimeout(node.__esToastTimer); } catch(e0) {}
      node.__esToastTimer = 0;
    }
    node.classList.remove('is-visible');
    node.classList.add('is-leaving');
    window.setTimeout(function(){
      try { if (node && node.parentNode) node.parentNode.removeChild(node); } catch(e1) {}
    }, 220);
  }

  function showToast(message, opts){
    if (!message) return null;
    var options = opts || {};
    var id = options.id ? String(options.id) : '';
    if (id) hideToast(id);
    var root = ensureToastRoot();
    var node = document.createElement('div');
    node.className = 'es-cart-toast';
    if (options.type === 'error') node.classList.add('is-error');
    else if (options.type === 'success') node.classList.add('is-success');
    else node.classList.add('is-info');
    if (options.loading) node.classList.add('is-loading');
    if (id) node.setAttribute('data-es-cart-toast-id', id);
    var content = document.createElement('div');
    content.className = 'es-cart-toast__content';
    var copy = document.createElement('span');
    copy.className = 'es-cart-toast__copy';
    copy.textContent = String(message);
    content.appendChild(copy);
    node.appendChild(content);
    root.appendChild(node);
    window.requestAnimationFrame(function(){ node.classList.add('is-visible'); });
    var duration = typeof options.duration === 'number' ? options.duration : (options.loading ? 0 : 2200);
    if (duration > 0) {
      node.__esToastTimer = window.setTimeout(function(){ hideToast(id || node); }, duration);
    }
    return node;
  }

  function hideToastNode(node){
    if (!node) return;
    if (typeof node === 'string') { hideToast(node); return; }
    try {
      if (node.__esToastTimer) window.clearTimeout(node.__esToastTimer);
      node.classList.remove('is-visible');
      node.classList.add('is-leaving');
      window.setTimeout(function(){ if (node.parentNode) node.parentNode.removeChild(node); }, 220);
    } catch(e) {}
  }

  function scheduleOpeningCartToast(form){
    if (!form) return;
    if (form.__esOpeningToastTimer) {
      try { window.clearTimeout(form.__esOpeningToastTimer); } catch(e0) {}
    }
    form.__esOpeningToastTimer = window.setTimeout(function(){
      form.__esOpeningToastTimer = 0;
      if (form.getAttribute('data-es-cart-submitting') !== 'true') return;
      showToast('Opening cart…', { id: 'es-cart-opening', type: 'info', loading: true, duration: 0 });
    }, LOADING_TOAST_DELAY_MS);
  }

  function clearOpeningCartToast(form){
    if (form && form.__esOpeningToastTimer) {
      try { window.clearTimeout(form.__esOpeningToastTimer); } catch(e0) {}
      form.__esOpeningToastTimer = 0;
    }
    hideToast('es-cart-opening');
  }

  function getCurrentState(){
    return {
      href: getCurrentHref(),
      path: window.location.pathname + window.location.search,
      x: Math.max(0, window.pageXOffset || window.scrollX || 0),
      y: Math.max(0, window.pageYOffset || window.scrollY || 0),
      ts: now(),
      title: document.title || ''
    };
  }

  function getBrowseState(){
    var state = read(STORAGE_KEY);
    if (!state || !state.href || !isRestorableUrl(state.href)) return null;
    if (state.ts && (now() - state.ts > MAX_AGE_MS)) {
      remove(STORAGE_KEY);
      return null;
    }
    return state;
  }

  function saveBrowseState(reason){
    if (!isRestorableUrl(window.location.href)) return null;
    var state = getCurrentState();
    if (reason) state.reason = String(reason);
    write(STORAGE_KEY, state);
    return state;
  }

  function scheduleSaveBrowseState(reason){
    if (saveTimer) window.clearTimeout(saveTimer);
    saveTimer = window.setTimeout(function(){
      saveTimer = 0;
      saveBrowseState(reason || 'debounced');
    }, 120);
  }

  function setReturnIntent(url){
    var state = getBrowseState() || saveBrowseState('return-intent');
    var href = normalize(url || (state && state.href) || FALLBACK_URL);
    if (!href || !isRestorableUrl(href)) return;
    write(RETURN_KEY, {
      href: href,
      x: state && typeof state.x === 'number' ? state.x : 0,
      y: state && typeof state.y === 'number' ? state.y : 0,
      ts: now()
    });
  }

  function getReturnIntent(){
    var intent = read(RETURN_KEY);
    if (!intent || !intent.href) return null;
    if (intent.ts && (now() - intent.ts > MAX_AGE_MS)) {
      remove(RETURN_KEY);
      return null;
    }
    return intent;
  }

  function clearReturnIntent(){ remove(RETURN_KEY); }

  function getContinueShoppingUrl(fallback){
    var state = getBrowseState();
    if (state && state.href && isRestorableUrl(state.href)) return state.href;
    return fallback || FALLBACK_URL;
  }

  function reserveContinueLinkWidth(link, defaultLabel, activeLabel){
    if (!link || !document || !document.body) return;
    var labels = [];
    if (defaultLabel) labels.push(String(defaultLabel));
    if (activeLabel) labels.push(String(activeLabel));
    if (!labels.length) return;
    try {
      var cs = window.getComputedStyle(link);
      var probe = document.createElement('span');
      probe.setAttribute('aria-hidden', 'true');
      probe.style.position = 'absolute';
      probe.style.left = '-99999px';
      probe.style.top = '0';
      probe.style.visibility = 'hidden';
      probe.style.pointerEvents = 'none';
      probe.style.whiteSpace = 'nowrap';
      probe.style.font = cs.font;
      probe.style.fontFamily = cs.fontFamily;
      probe.style.fontSize = cs.fontSize;
      probe.style.fontWeight = cs.fontWeight;
      probe.style.fontStyle = cs.fontStyle;
      probe.style.letterSpacing = cs.letterSpacing;
      probe.style.textTransform = cs.textTransform;
      probe.style.fontKerning = cs.fontKerning;
      probe.style.fontVariant = cs.fontVariant;
      document.body.appendChild(probe);
      var maxText = 0;
      labels.forEach(function(label){
        probe.textContent = label;
        var w = Math.ceil(probe.getBoundingClientRect().width || 0);
        if (w > maxText) maxText = w;
      });
      probe.remove();
      var padding = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0);
      var border = (parseFloat(cs.borderLeftWidth) || 0) + (parseFloat(cs.borderRightWidth) || 0);
      var reserved = Math.ceil(maxText + padding + border + 4);
      var currentMin = parseFloat(link.style.minWidth) || 0;
      if (reserved > currentMin) {
        link.style.minWidth = reserved + 'px';
      }
    } catch(e) {}
  }

  function goToCart(){
    try {
      var state = saveBrowseState('goto-cart');
      if (state && state.href) setReturnIntent(state.href);
    } catch(e) {
      try { setReturnIntent(getCurrentHref()); } catch(e2) {}
    }
    var destination = routeUrl('cart');
    try { window.location.assign(destination); }
    catch(e){ window.location.href = destination; }
  }

  function applyContinueShoppingLinks(scope){
    var root = scope && scope.querySelectorAll ? scope : document;
    var links = root.querySelectorAll ? root.querySelectorAll('[data-es-continue-shopping]') : [];
    if (!links.length) return;
    var state = getBrowseState();
    links.forEach(function(link){
      if (!link) return;
      var fallback = link.getAttribute('data-es-continue-fallback') || FALLBACK_URL;
      var defaultLabel = link.getAttribute('data-es-default-label') || link.textContent.trim() || 'Continue shopping';
      var activeLabel = link.getAttribute('data-es-active-label') || 'Continue shopping';
      var href = getContinueShoppingUrl(fallback);
      link.setAttribute('href', href);
      reserveContinueLinkWidth(link, defaultLabel, activeLabel);
      if (state && state.href && isRestorableUrl(state.href)) {
        link.textContent = activeLabel;
        link.removeAttribute('aria-disabled');
        link.classList.remove('is-disabled');
      } else {
        link.textContent = defaultLabel;
      }
      if (!link.__esContinueBound) {
        link.__esContinueBound = true;
        link.addEventListener('click', function(){
          setReturnIntent(link.getAttribute('href') || fallback);
        });
      }
    });
  }


  // Continue-shopping labels exist on Cart only. Avoid a post-font full-document scan
  // on product grids and PDPs where this script is also responsible for add-to-cart locking.
  var hasContinueShoppingLinks = !!document.querySelector('[data-es-continue-shopping]');
  if (hasContinueShoppingLinks && document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
    try {
      document.fonts.ready.then(function(){
        try { applyContinueShoppingLinks(document); } catch(e) {}
      });
    } catch(e) {}
  }

  function clearPendingRestoreState(delay){
    var releaseDelay = typeof delay === 'number' ? delay : 0;
    window.setTimeout(function(){
      try { document.documentElement.removeAttribute('data-es-cart-restore-pending'); } catch(e) {}
      try { delete window.__esCartRestoreTarget; } catch(e2) { window.__esCartRestoreTarget = null; }
    }, releaseDelay);
  }

  function getEarlyRestoreTarget(current, browseState){
    var target = window.__esCartRestoreTarget;
    if (!target || !samePage((target.href || current), current)) return null;
    return {
      x: typeof target.x === 'number' ? target.x : (browseState && browseState.x) || 0,
      y: typeof target.y === 'number' ? target.y : (browseState && browseState.y) || 0
    };
  }

  function restoreScrollIfNeeded(){
    if (!isRestorableUrl(window.location.href)) {
      clearPendingRestoreState(0);
      return;
    }
    var current = normalize(window.location.href);
    if (!current) {
      clearPendingRestoreState(0);
      return;
    }
    var browseState = getBrowseState();
    var returnIntent = getReturnIntent();
    var target = getEarlyRestoreTarget(current, browseState);
    if (!target && returnIntent && samePage(returnIntent.href, current)) {
      target = {
        x: typeof returnIntent.x === 'number' ? returnIntent.x : (browseState && browseState.x) || 0,
        y: typeof returnIntent.y === 'number' ? returnIntent.y : (browseState && browseState.y) || 0
      };
    }
    if (returnIntent && samePage(returnIntent.href, current)) {
      clearReturnIntent();
    } else if (!target) {
      try {
        var ref = document.referrer ? new URL(document.referrer, window.location.origin) : null;
        if (ref && ref.origin === window.location.origin && isCartUrl(ref.href) && browseState && samePage(browseState.href, current)) {
          target = {
            x: typeof browseState.x === 'number' ? browseState.x : 0,
            y: typeof browseState.y === 'number' ? browseState.y : 0
          };
        }
      } catch(e) {}
    }
    if (!target) {
      clearPendingRestoreState(0);
      return;
    }
    var restore = function(){
      try { window.scrollTo(target.x || 0, target.y || 0); } catch(e) {}
    };
    if ('scrollRestoration' in history) {
      try { history.scrollRestoration = 'manual'; } catch(e) {}
    }
    window.requestAnimationFrame(function(){
      restore();
      clearPendingRestoreState(24);
      window.setTimeout(restore, 80);
      window.setTimeout(restore, 220);
      window.setTimeout(restore, 520);
      window.setTimeout(clearPendingRestoreState, 560);
    });
  }

  function releaseLockedControls(scope){
    var root = scope && scope.querySelectorAll ? scope : document;
    var controls = root.querySelectorAll ? root.querySelectorAll('[data-es-cart-locked="1"]') : [];
    controls.forEach(function(control){
      if (!control) return;
      control.dataset.esCartLocked = '0';
      control.removeAttribute('data-es-cart-locked');
      try { control.disabled = false; } catch(err) {}
      control.removeAttribute('aria-busy');
      control.removeAttribute('data-es-cart-primary-submit');
      control.classList.remove('es-cart-submit-lock');
      removeBusyPresentation(control);
    });
    var forms = [];
    if (scope && scope.matches && scope.matches('form[action*="/cart/add"]')) {
      forms.push(scope);
    }
    if (root.querySelectorAll) {
      root.querySelectorAll('form[action*="/cart/add"][data-es-cart-submitting="true"], form[action*="/cart/add"].es-cart-form-submitting').forEach(function(form){
        forms.push(form);
      });
    }
    forms.forEach(function(form){
      if (!form || !form.setAttribute) return;
      form.setAttribute('data-es-cart-submitting', 'false');
      form.classList.remove('es-cart-form-submitting');
      clearClickArmedState(form);
      clearOpeningCartToast(form);
      if (form.__esClickArmTimer) {
        try { window.clearTimeout(form.__esClickArmTimer); } catch(e2) {}
        form.__esClickArmTimer = 0;
      }
    });
  }

  function bindAddToCartLocking(){
    document.addEventListener('click', function(e){
      var control = e.target && e.target.closest ? e.target.closest('button, input[type="submit"]') : null;
      if (!isAddToCartSubmitControl(control)) return;
      var form = control.form || (control.closest ? control.closest('form') : null);
      if (!isAddToCartForm(form)) return;
      if (form.getAttribute('data-es-cart-submitting') === 'true' || control.getAttribute('data-es-cart-locked') === '1' || control.getAttribute('data-es-cart-pending') === '1' || control.getAttribute('aria-busy') === 'true') {
        e.preventDefault();
        e.stopPropagation();
        showToast('Opening cart…', { id: 'es-cart-opening', type: 'info', loading: true, duration: 1400 });
        return;
      }
      saveBrowseState('add-button-click');
      armControlPending(form, control);
    }, true);

    document.addEventListener('submit', function(e){
      var form = e.target;
      if (!isAddToCartForm(form)) return;
      saveBrowseState('add-form-submit');
      if (form.getAttribute('data-es-cart-submitting') === 'true') {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      form.setAttribute('data-es-cart-submitting', 'true');
      form.classList.add('es-cart-form-submitting');
      if (form.__esClickArmTimer) {
        try { window.clearTimeout(form.__esClickArmTimer); } catch(eTimer) {}
        form.__esClickArmTimer = 0;
      }
      var submitter = e.submitter || null;
      var controls = form.querySelectorAll('button[type="submit"], input[type="submit"]');
      controls.forEach(function(control){
        if (!control) return;
        control.dataset.esCartLocked = '1';
        control.setAttribute('data-es-cart-locked', '1');
        try { control.disabled = true; } catch(err) {}
        control.setAttribute('aria-busy', 'true');
        control.classList.remove('es-cart-submit-pending');
        control.removeAttribute('data-es-cart-pending');
        control.classList.add('es-cart-submit-lock');
        applyBusyPresentation(control, 'Opening cart…');
      });
      form.removeAttribute('data-es-cart-click-armed');
      if (submitter && submitter.setAttribute) {
        submitter.setAttribute('data-es-cart-primary-submit', '1');
      }
      scheduleOpeningCartToast(form);
      window.setTimeout(function(){
        releaseLockedControls(form);
        if (submitter && submitter.removeAttribute) {
          submitter.removeAttribute('data-es-cart-primary-submit');
        }
      }, LOCK_FALLBACK_MS);
    }, true);

    window.addEventListener('pageshow', function(){
      releaseLockedControls(document);
    });

    window.addEventListener('pagehide', function(){
      hideToast('es-cart-opening');
      releaseLockedControls(document);
    });
  }

  function bindCartLinks(){
    document.addEventListener('click', function(e){
      var link = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!link) return;
      var href = link.getAttribute('href') || '';
      if (!href) return;
      if (isCartUrl(href)) saveBrowseState('cart-link');
    }, true);
  }

  function init(){
    if (isRestorableUrl(window.location.href)) {
      saveBrowseState('init');
      // ES PERF 1482: do not serialize and write sessionStorage throughout scrolling.
      // Cart-link clicks, add-to-cart clicks/submits, visibility changes and pagehide all
      // capture the final position at the moment it matters for Continue Shopping restore.
      // pagehide also avoids the BFCache penalty associated with a beforeunload listener.
      document.addEventListener('visibilitychange', function(){ if (document.visibilityState === 'hidden') saveBrowseState('hidden'); });
      window.addEventListener('pagehide', function(){ saveBrowseState('pagehide'); });
      window.addEventListener('pageshow', function(){
        restoreScrollIfNeeded();
      });
    }
    bindAddToCartLocking();
    bindCartLinks();
    if (hasContinueShoppingLinks) applyContinueShoppingLinks(document);
    restoreScrollIfNeeded();
  }

  window.EyeshellsCartNav = window.EyeshellsCartNav || {
    saveBrowseState: saveBrowseState,
    scheduleSaveBrowseState: scheduleSaveBrowseState,
    getBrowseState: getBrowseState,
    setReturnIntent: setReturnIntent,
    getContinueShoppingUrl: getContinueShoppingUrl,
    refreshContinueShoppingLinks: applyContinueShoppingLinks,
    restoreScrollIfNeeded: restoreScrollIfNeeded,
    goToCart: goToCart,
    showToast: showToast,
    hideToast: hideToastNode
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
